import { useState } from 'react'
import './SnackCardImg.scss'

const baseImgUrl = process.env.REACT_APP_CINESTAR_IMAGES_FROM_CMS_BASE_URL

const SnackCardImg = ({ name, voucherid }) => {
    const [error, setError] = useState(false)
    return (
        <div className="snack-card-img d-flex justify-content-center align-items-center">
            <img
                src={!error ? `${baseImgUrl}w_${voucherid}.png` : 'images/cinestar/popcorn-menu.png'}
                alt={name}
                onError={() => setError(true)}
            />
        </div>
    )
}

export default SnackCardImg
